const INSUFFICIENT_CONTEXT_ERROR = 'Grabbed context does not meet minimum context requirements';

export const isInsufficientContextError = (error: Error): boolean => {
	return error.message.includes(INSUFFICIENT_CONTEXT_ERROR);
};
